import Index from '../views/Index/index.vue'
import { trackEvent } from '../lib/js/trackEvent/index'

const backDialogReg = /BackDialog/
const domainReg = /^(https:\/\/dpubstatic.udache.com|https:\/\/ut-static.udache.com|https:\/\/gift-pre-inter.didistatic.com)(.)+?(\.jpg|\.png|\.jpeg)$/
const commonImgReg = /^https:\/\/(.)+?(\.jpg|\.png|\.jpeg)$/
const coreImagesList = []
const coreImagesMap = {
  DpubHeadImage: true,
  DpubContentImage: true,
  UtlaunchLargeTurntable: true,
  UtlaunchRedPacketMarketing: true,
  UtlaunchSlotMachine: true,
  UtlaunchUtImage: true
}

function upFirstPageShowEvt () {
  // 性能埋点：首页全部展现
  if (__isServerRender__ || !coreImagesList.length) return
  if (window.__INITIAL_STATE__) {
    // console.log('upFirstPageShowEvt domReady');
    window.PerfTrack.domReady()
  }
  window.PerfTrack.customTTI({
    immediate: false,
    isKey: true,
    resources: coreImagesList.slice(0, 4),
    isServer: window.store.state.prefetched
  })
}

function addCoreImage (compType, url) {
  coreImagesMap[compType] && coreImagesList.push(url)
}

// 图片转成webp格式并收集图片以做性能埋点（首页全部展现）上报
function translateImgToWebp (imgUrl, compShow, compType) {
  const url = !__isServerRender__ && window.__CAN_WEBP__ ? `${imgUrl}?x-s3-process=image/format,webp` : imgUrl
  compShow && addCoreImage(compType, url)
  return url
}

function handleProps (props, compShow, compType) {
  if (typeof props !== 'object') {
    if (domainReg.test(props)) {
      return translateImgToWebp(props, compShow, compType)
    } else {
      if (commonImgReg.test(props)) {
        compShow && addCoreImage(compType, props)
      }
      return props
    }
  }
  const res = Array.isArray(props) ? [] : {}
  for (const i in props) {
    res[i] = handleProps(props[i], compShow, compType)
  }
  return res
}

function formatToWebp (layers) {
  for (let i = 0; i < layers.length; i++) {
    const layer = layers[i]
    const { props, editorStatus: { show }, children, type } = layer
    layer.props = handleProps(props, show, type)
    if (children && children.length) {
      layer.children = formatToWebp(children)
    }
  }
  return layers
}

const mutations = {
  setAsyncComps (state, payload) {
    state.compMap = payload
  },
  initPageData (state, payload) {
    payload.scenes.layers = formatToWebp(payload.scenes.layers)
    upFirstPageShowEvt()
    state.originLayers = JSON.parse(JSON.stringify(payload.scenes.layers))

    // 生成组件展示map
    const originLayersShowMap = {}
    state.originLayers.forEach(layer => {
      const { editorStatus: { show }, id, key } = layer
      if (backDialogReg.test(key)) {
        state.backPopup = { id, show: !show }
      }
      originLayersShowMap[id] = show
    })
    state.originLayersShowMap = originLayersShowMap
    // 过滤掉首次渲染不需要的组件
    payload.scenes.layers = payload.scenes.layers.filter(layer => originLayersShowMap[layer.id])
    state.page = payload
  },
  setPageData (state, { id, show } = {}) {
    const { originLayersShowMap, originLayers } = state
    id && (originLayersShowMap[id] = show)
    const newOriginLayers = JSON.parse(JSON.stringify(originLayers))
    const newLayers = newOriginLayers.filter(layer => originLayersShowMap[layer.id])
    state.page.scenes.layers = newLayers
  },
  setEventTable (state, data) {
    if (!data) return
    const { dataCenter } = state
    // 处理eventTable
    const eventTable = data.scenes.eventTable
    for (const evtKey in eventTable) {
      const evt = eventTable[evtKey]
      const { refId, eventName } = evt
      dataCenter.eventTable[refId] = dataCenter.eventTable[refId] || {}
      dataCenter.eventTable[refId][eventName] = evt
    }
  },
  setPubData (state, data) {
    const { key, val } = data
    state.dataCenter[key] = val
  },
  setOriginPageData (state, data) {
    state.originPageData = JSON.parse(JSON.stringify(data))
  },
  handleMultiPage (state, data) {
    if (__isServerRender__) return
    const multiPages = data?.scenes?.multiPages || null
    const pageDataMap = {}
    const popupDataMap = {}
    const newRoutes = []
    if (multiPages && multiPages.length) {
      state.isMultiPage = true
      multiPages.forEach(page => {
        let { isRouterPage, pageKey, linkToPage, layers } = page
        if (isRouterPage === 'page') {
          newRoutes.push({
            path: `/${pageKey}`,
            name: pageKey,
            component: Index,
          })
          if (popupDataMap[pageKey]) {
            pageDataMap[pageKey] = layers.concat(popupDataMap[pageKey])
          } else {
            pageDataMap[pageKey] = layers
          }
        } else {
          // 非独立页面的组件，让其隐藏
          layers = layers.map(layer => {
            layer.editorStatus.show = false
            return layer
          })
          if (pageDataMap[linkToPage]) {
            pageDataMap[linkToPage] = pageDataMap[linkToPage].concat(layers)
          } else {
            popupDataMap[linkToPage] = layers
          }
        }
      })
      window.router.addRoutes(newRoutes)
      state.multiPageDataMap = pageDataMap
    }
  },
  setObserveCount (state, data) {
    state.observeCount = data
  },
  initIo (state) {
    if (__isServerRender__) return
    state.io = new IntersectionObserver((entries) => {
      entries.forEach(item => {
        // intersectionRatio > 0说明该元素露出
        if (item.intersectionRatio > 0) {
          // 埋点上报
          const id = item.target.id
          if (id) {
            const classStr = item.target.className
            const isHot = classStr.search(/hot-area/) > -1
            const isSlider = classStr.search(/slide/) > -1
            const weigetType = isHot ? 'hotArea' : (isSlider ? 'slider' : 'custom')
            const parentId = item.target?.parentElement?.parentElement?.id
            const filterId = isHot ? parentId : id
            const showWidget = state.page.scenes.layers.filter(layer => {
              return layer.id === filterId
            })
            const paramMap = {
              hotArea: {
                type: 'hotArea',
                zj_id: parentId,
                hot_area_id: id,
                label: `${showWidget[0].name}-热区曝光`
              },
              slider: {
                type: 'slider',
                zj_id: id,
                banner_num: item.target.getAttribute('data-index'),
                label: `${showWidget[0].name}图片曝光`
              },
              custom: {
                type: 'custom',
                zj_id: id,
                label: `${showWidget[0].name}曝光` || '组件曝光'
              }
            }
            if (isSlider) {
              state.sliderMap[id] = {
                len: item.target.getAttribute('data-len'),
                banners: []
              }
            }
            trackEvent('userteam_ad_zj_pub_sw', paramMap[weigetType])
            state.hasTrackLayers = [
              ...state.hasTrackLayers,
              id
            ]
          }
          state.io.unobserve(item.target)
          state.observeCount--
          if (state.observeCount === 0) state.io.disconnect()
        }
      })
    }, {
      root: null,
    })
  }
}

export default mutations
